// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__wdH4_","container":"styles_container__of1RB","closeButton":"styles_closeButton__j3KXg"};